import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import * as dayjs from 'dayjs';
import { DxDataGridComponent } from 'devextreme-angular';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfMake from 'pdfmake/build/pdfmake';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AWSService } from 'src/app/provider/aws.service';
import { NewRequestComponent } from 'src/app/views/component/popup/new-request/new-request.component';
import { NewReservationComponent } from 'src/app/views/component/popup/new-reservation/new-reservation.component';
import { MenuAsideService } from '../../../../core/_base/layout';
import { AppHotelService } from '../../../../provider/app-hotel.service';
import { ChatService } from '../../../../provider/chat.service';
import { RequestActionService } from '../../../../provider/request-action.service';
import { RequestsService } from '../../../../provider/requests.service';
import { SurveyResearchService } from '../../../../provider/survey-research.service';
import { AppHotelModel } from '../../../models/app-hotel.model';
import { RequestActionModel } from '../../../models/request-action.model';
import { RequestHeaderModel } from '../../../models/request-header.model';
import { PrinterService } from 'src/app/provider/printer.service';
import { RequestLineModel } from 'src/app/views/models/request-line.model';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'kt-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss']
})
export class RequestsComponent implements OnInit, AfterViewInit, OnDestroy {
  test: any[][] = [[]];
  ChatIsVisible = false;
  ESCAPE_KEYCODE = 27;

  editorOptions: object;
  currentRequest: RequestHeaderModel = new RequestHeaderModel();
  currentRequestRedeem: RequestLineModel = new RequestLineModel();
  currentHotelInfo: AppHotelModel;

  is_processing = new BehaviorSubject<boolean>(false);
  quest_mark = new BehaviorSubject<boolean>(true);
  completed = new BehaviorSubject<boolean>(false);



  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  requests: RequestHeaderModel[];
  popupVisible = false;
  popupVisibleRedeem = false;
  total = 0;
  requestAction: RequestActionModel = new RequestActionModel();
  inProcess = false;
  managed = false;
  private edit = false;
  rate: number;
  loading = true;
  guest_visible = true;
  time = new Date().getTime();
  destroyed$ = new Subject();
  types: any[] = [];
  typeID = 'all';

  printer: string = null;
  template = 'kitchen';

  reportDay = 14;

  constructor(
    public requestService: RequestsService,
    private appHotel: AppHotelService,
    private menuAsideService: MenuAsideService,
    public requestActionService: RequestActionService,
    public chatService: ChatService,
    public surveyResearchService: SurveyResearchService,
    private mdlctrl: MatDialog,
    private awsServ: AWSService,
    public printerServ: PrinterService,
    private translateServ: TranslateService

  ) {

    this.chatService.GetChatHeaders();
    this.menuAsideService.pathname$.next(window.location.pathname);
    this.guest_visible = JSON.parse(localStorage.getItem('token_form')).guest_visible;
    this.editorOptions = {
      itemTemplate: 'statusTemplate'
    };
    this.requestService.getRequest();
    // setInterval(() => {
    this.chatService.GetChatHeaders();
    // }, 180 * 1000);

    this.requestService.request_change$.subscribe((resp: RequestHeaderModel[]) => {
      console.log(resp);
      if (resp.length != 0 || resp) {
        this.loading = false;
      }
      const types = new Set(resp.map(x => x.menu_section_id));
      this.types = Array.from(types);

      if (this.typeID != 'all') {
        this.requestService.request_change_filtered.next(this.requestService.request_change$.getValue().filter(x => x.menu_section_id == +this.typeID));
      } else {
        this.requestService.request_change_filtered.next(this.requestService.request_change$.getValue());
      }
    });
    this.appHotel.getHotelInfo(+localStorage.getItem('hotelId')).subscribe(
      (hotelInfo: AppHotelModel) => {
        this.currentHotelInfo = hotelInfo;
      }
    );
  }

  async ngOnInit() {
    await this.printerServ.getPrinters();
    this.printer = this.printerServ.printers[0] ? this.printerServ.printers[0].id.toString() : null;


  }

  ngOnDestroy(): void {
    this.requestService.disconnectWs();
    this.destroyed$.next();
  }

  updateReportDay() {
    this.requestService.getRequest(null, `-${this.reportDay}d`);
  }

  ngAfterViewInit(): void {
    this.appHotel.getHotelInfo(+localStorage.getItem('hotelId')).subscribe(
      (hotel) => {
        this.requestService.connectWs((hotel.group_hotels.split(',').join('-') ? hotel.group_hotels.split(',').join('-') : hotel.id.toString())).pipe(
          takeUntil(this.destroyed$)
        ).subscribe(request => {
          this.requestService.addRequest(request);
          setTimeout(() => {
          }, 200);
        }, (err) => {
          console.log('Web Socket Error : ' + err);
        }, () => {
          console.log('Web Socket is completed');
          setTimeout(() => {
          }, 200);
        });
      }
    );
  }

  // completeRedeem(id: string, ID) {
  //   console.log(id)
  //   this.requestService.putRedeemStatus(id, ID);
  //   console.log("completeRedeem")
  //   this.is_processing.next(true);
  //   this.quest_mark.next(false);
  //   setTimeout(() => {
  //     this.completed.next(true);
  //     this.is_processing.next(false);
  //   }, 3000)
  // }

  // ShowRedeem(data) {
  //   // this.requestService.getRequestById(data.data.request_header_id)
  //   this.currentRequestRedeem = data.data;
  //   this.popupVisibleRedeem = true;

  // }


  openChat(ChatRequest: RequestHeaderModel) {
    this.ChatIsVisible = !this.ChatIsVisible;
    if (this.ChatIsVisible) {
      this.currentRequest = ChatRequest;
    } else {
      this.currentRequest = new RequestHeaderModel();
    }
  }

  closeChat() {
    this.ChatIsVisible = false;
  }

  async Show(data: RequestHeaderModel) {
    console.log(data)

    this.requestService.getRequestById(data.id)
    console.log(this.requestService.currentRedeemRequest)
    this.requestService.translated_text_change$.next('');
    this.inProcess = false;
    this.managed = false;
    console.log(data.id)
    this.currentRequest = data;
    this.popupVisible = true;

    console.log(this.currentRequest)

    this.surveyResearchService.getSurvey(this.currentRequest.id).subscribe((result) => {
      this.rate = result.rate;
    });

    this.requestActionService.getTitleAndDescription(this.currentRequest.menu_item_id, this.currentRequest.requestlines[0].no);
    this.chatService.GetRequestChats(this.currentRequest.id);

    this.total = 0;

    if (this.currentRequest.requestlines) {
      this.currentRequest.requestlines.forEach(x => this.total += x.amount);
    }
    setTimeout(() => {
      this.popupVisible = false;
    }, 1000)
  }

  updateStatus(req: RequestHeaderModel, status: string) {
    req.status = status;
    this.requestService.putRequest(req);
  }

  // SetData(status: string) {
  //   if (status == 'Managed' && this.edit) {
  //     status = 'Updated';
  //     this.edit = false;
  //   }
  //   if (this.requestActionService.titleDescription_change$.getValue().closing_values && status == 'Managed' && !this.managed) {
  //     this.managed = true;
  //     return;
  //   } else if (this.requestActionService.titleDescription_change$.getValue().reason_values && status == 'In Process' && !this.inProcess) {
  //     this.inProcess = true;
  //     return;
  //   }
  //   this.requestService.putStatus(
  //     this.currentRequest.id,
  //     this.currentRequest.managed_by_user,
  //     status,
  //     this.currentRequest.staff_note,
  //     this.currentRequest.place_code
  //   );
  //   if (this.requestAction.current_status) {
  //     this.requestAction.state = status;
  //     this.requestAction.no = this.currentRequest.id;
  //     this.requestActionService.postRequestAction(this.requestAction);
  //     this.requestAction = new RequestActionModel();
  //   }
  //   this.inProcess = false;
  //   this.managed = false;

  //   this.popupVisible = false;
  // }

  getVisible(name: string) {
    let first: string = name.substring(0, 1);
    for (let i = 1; name.length > i; i++) {
      first += '*';
    }
    return first;
  }

  async newRequest() {
    await this.mdlctrl.open(NewRequestComponent, { width: '50vw' });
  }

  async newReservation() {
    await this.mdlctrl.open(NewReservationComponent, { width: '75vw' });
  }

  async generatePdf() {
    const IMG = await this.awsServ.getBase64('https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/' + this.currentRequest.hotel_id + '/DarkLogo/' + this.currentRequest.hotel_id + '.jpg?' + this.time);

    const LINES: any = [
      [
        {
          text: 'ITEM DESCRIPTION',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'ITEM TOTAL',
          border: [false, true, false, true],
          alignment: 'right',
          fillColor: '#eaf2f5',
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        }
      ]
    ];

    const COLUMNS = [];

    this.currentRequest.requestlines.forEach(item => {

      LINES.push(
        [
          {
            text: item.name.replace(/<\/?[^>]+>/gi, '') + '\n' + item.note,
            border: [false, false, false, true],
            margin: [0, 5, 0, 5],
            alignment: 'left',
          },
          {
            border: [false, false, false, true],
            text: `${item.currency_code}${item.amount}`,
            fillColor: '#f5f5f5',
            alignment: 'right',
            margin: [0, 5, 0, 5],
          }
        ]
      );
    });

    const PDF = {
      content: [
        {
          columns: [
            {
              image: IMG,
              width: 150,
            },
            [
              {
                text: 'Receipt',
                color: '#333333',
                width: '*',
                fontSize: 20,
                bold: true,
                alignment: 'right',
                margin: [0, 0, 0, 15],
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: 'Id',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: this.currentRequest.id,
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: 'Date Issued',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: dayjs(this.currentRequest.created_at).format('DD/MM/YYYY'),
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: 'Status',
                        color: '#aaaaab',
                        bold: true,
                        fontSize: 12,
                        alignment: 'right',
                        width: '*',
                      },
                      {
                        text: this.currentRequest.status,
                        bold: true,
                        fontSize: 14,
                        alignment: 'right',
                        color: '#333333',
                        width: 100,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: 'From',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
            {
              text: 'To',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
          ],
        },
        {
          columns: [
            {
              text: `${this.currentRequest.hotel_name}`,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
            {
              text: `${this.currentRequest.profile_name}`,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
          ],
        },
        {
          columns: [
            {
              text: 'Address',
              color: '#aaaaab',
              bold: true,
              margin: [0, 7, 0, 3],
            },
            {}
          ],
        },
        {
          columns: [
            {
              text: this.currentHotelInfo.address,
              style: 'invoiceBillingAddress',
            }
          ],
        },
        '\n\n',
        {
          width: '100%',
          alignment: 'center',
          text: `Invoice No. ${this.currentRequest.id}`,
          bold: true,
          margin: [0, 10, 0, 10],
          fontSize: 15,
        },
        {
          layout: {
            defaultBorder: false,
            hLineWidth(i, node) {
              return 1;
            },
            vLineWidth(i, node) {
              return 1;
            },
            hLineColor(i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor(i, node) {
              return '#eaeaea';
            },
            hLineStyle(i, node) {
              return null;
            },
            paddingLeft(i, node) {
              return 10;
            },
            paddingRight(i, node) {
              return 10;
            },
            paddingTop(i, node) {
              return 2;
            },
            paddingBottom(i, node) {
              return 2;
            },
            fillColor(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: ['*', 80],
            body: LINES,
          },
        },
        '\n',
        '\n\n',
        {
          layout: {
            defaultBorder: false,
            hLineWidth(i, node) {
              return 1;
            },
            vLineWidth(i, node) {
              return 1;
            },
            hLineColor(i, node) {
              return '#eaeaea';
            },
            vLineColor(i, node) {
              return '#eaeaea';
            },
            hLineStyle(i, node) {
              return null;
            },
            paddingLeft(i, node) {
              return 10;
            },
            paddingRight(i, node) {
              return 10;
            },
            paddingTop(i, node) {
              return 3;
            },
            paddingBottom(i, node) {
              return 3;
            },
            fillColor(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: ['*', 'auto'],
            body: [
              [
                {
                  text: 'Total Amount',
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: `${this.currentRequest.requestlines[0].currency_code}${this.total}`,
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, true],
                  fillColor: '#f5f5f5',
                  margin: [0, 5, 0, 5],
                },
              ],
            ],
          },
        },
        '\n\n',
        {
          text: 'NOTES',
          style: 'notesTitle',
        },
        {
          text: this.currentRequest.note,
          style: 'notesText',
        }
      ],
      styles: {
        notesTitle: {
          fontSize: 10,
          bold: true,
          margin: [0, 20, 0, 3],
        },
        notesText: {
          fontSize: 10,
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    pdfMake.createPdf(PDF).open();
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.code == 'Escape') {
      this.closeChat();
    }
  }

  getData(data: string) {
    return data.split('|');
  }

  onChange(type, value) {
    const oldDate = new Date(this.currentRequest.order_date);
    switch (type) {
      case 'hour':
        const requestTime = new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate(), +value.split(':')[0], +value.split(':')[1]);
        this.currentRequest.order_date = requestTime;
        break;
      case 'date':
        const requestDate = new Date(value.split('/')[2], value.split('/')[1], value.split('/')[0], oldDate.getHours(), oldDate.getMinutes());
        this.currentRequest.order_date = requestDate;
        break;
    }
    this.requestService.putRequest(this.currentRequest);
    this.edit = true;
  }

  onRowPrepared(e) {
    if (e.rowType == 'data' && e.data.status == 'Finished') {
      e.rowElement.style.backgroundColor = '#32cd3259';
    }
  }

  getBadge(id) {
    if (this.chatService.chatHeaders.getValue().length > 0) {
      if (this.chatService.chatHeaders.getValue().find(x => x.id == id)) {
        return this.chatService.chatHeaders.getValue().find(x => x.id == id).badge;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  filter(type: any) {
    this.typeID = type;
    if (type != 'all') {
      this.requestService.request_change_filtered.next(this.requestService.request_change$.getValue().filter(x => x.menu_section_id == type));
    } else {
      this.requestService.request_change_filtered.next(this.requestService.request_change$.getValue());
    }
  }

  getSectionName(type: any) {
    return this.requestService.request_change$.getValue().find(x => x.menu_section_id == type).menu_section_name;
  }

  printReceipt() {
    if (this.template === 'check') {
      this.printerServ.check(this.currentHotelInfo, this.currentRequest, +this.printer, this.printerServ.printers.find(x => x.id == +this.printer).printer_alias);
    } else {
      this.printerServ.kitchen(this.currentHotelInfo, this.currentRequest, +this.printer, this.printerServ.printers.find(x => x.id == +this.printer).printer_alias);
    }
  }

  startExport(event: any) {
    let description;
    this.translateServ.get('order_list').subscribe((text: string) => { description = text; });
    event.component.beginUpdate();

    event.component.columnOption('option', 'visible', false);

    event.fillPatternType = 'darkHorizontal';



    event.fileName = `${description}  ${this.currentHotelInfo.name}`;
  }

  finishExport(event: any) {
    event.component.beginUpdate();

    event.component.columnOption('option', 'visible', true);


  }
}
